import useBreakdownDataLicensingFee, {
  StudentInfo,
} from '../../../../../hooks/useBreakdownDataLicensingFee'
import { DirectorLicensingFeePerRateBreakdown } from '../../../../../swagger'
import { prepareLicensingData } from '../../LcdLicensingFeeReport/prepareLicensingData'

interface UseBreakdownDataReturn {
  licensingFeeFirstStudent: StudentInfo
  licensingFeeAdditionalStudent: StudentInfo
  licensingFeeSubtotal: string

  semester1FirstStudent: StudentInfo
  semester1AdditionalStudent: StudentInfo
  semester1Subtotal: string

  semester2FirstStudent: StudentInfo
  semester2AdditionalStudent: StudentInfo
  semester2Subtotal: string
}

interface UseBreakdownDataProps {
  breakdown: DirectorLicensingFeePerRateBreakdown[]
}

export const useBreakdownData = ({
  breakdown,
}: UseBreakdownDataProps): UseBreakdownDataReturn => {
  const {
    firstSpotInvitation,
    additionalSpotsInvitation,
    semester1FirstStudentsInfo,
    semester1AdditionalStudentInfo,
    semester2FirstStudentsInfo,
    semester2AdditionalStudentInfo,
  } = prepareLicensingData(breakdown)

  const {
    firstStudent: licensingFeeFirstStudent,
    additionalStudent: licensingFeeAdditionalStudent,
    subTotal: licensingFeeSubtotal,
  } = useBreakdownDataLicensingFee({
    semesterStudentInfo: firstSpotInvitation,
    semesterAdditionalStudentInfo: additionalSpotsInvitation,
  })

  const {
    firstStudent: semester1FirstStudent,
    additionalStudent: semester1AdditionalStudent,
    subTotal: semester1Subtotal,
  } = useBreakdownDataLicensingFee({
    semesterStudentInfo: semester1FirstStudentsInfo,
    semesterAdditionalStudentInfo: semester1AdditionalStudentInfo,
  })

  const {
    firstStudent: semester2FirstStudent,
    additionalStudent: semester2AdditionalStudent,
    subTotal: semester2Subtotal,
  } = useBreakdownDataLicensingFee({
    semesterStudentInfo: semester2FirstStudentsInfo,
    semesterAdditionalStudentInfo: semester2AdditionalStudentInfo,
  })

  return {
    licensingFeeFirstStudent,
    licensingFeeAdditionalStudent,
    licensingFeeSubtotal,

    semester1FirstStudent,
    semester1AdditionalStudent,
    semester1Subtotal,

    semester2FirstStudent,
    semester2AdditionalStudent,
    semester2Subtotal,
  }
}
